import React from 'react'
import './cart-button.scss';
import {ErrorBoundary} from 'react-error-boundary';
import classNames from 'classnames';
import {FormattedMessage} from 'react-intl';
import ErrorFallback from '../../../components/ErrorFallback';
import ShoppingBag03 from '../../../assets/icons0/shopping-bag-03.svg';
import Button from '../../../components/button/button';
import Amount from './amount';

const CartButton = ({serviceById, localCartState, isLocalCartDeferred, setCartVisibility, isStem}) => {
    return (
        <div className=''>
            <div className='display-none mw768-display-block min-width-11rem'>
                <Button {...{size: 'lg', color: 'primary-gradient', fluid: 'always', additionalClasses: 'cart-btn--disabled cart-btn', disabled: !localCartState.length, clickHandler: () => setCartVisibility(true)}}>
                    {localCartState.length ?
                        <React.Suspense fallback={
                            <>
                                <ShoppingBag03 className='display-block height-1dot25rem margin-right-0dot5rem opacity-0dot4 cart-btn__amount-icon'/>
                                <span className='opacity-0dot4 cart-btn__amount'>0.00 <FormattedMessage defaultMessage='UAH'/></span>
                            </>
                        }>
                            <ShoppingBag03 className={classNames('display-block height-1dot25rem margin-right-0dot5rem cart-btn__amount-icon', {'opacity-0dot4': isLocalCartDeferred})}/>
                            <ErrorBoundary {...{FallbackComponent: ErrorFallback}}>
                                <Amount {...{localCartState, serviceId: serviceById.id, deferred: isLocalCartDeferred, classes: 'cart-btn__amount', isStem, theme: 'primary'}}/>
                            </ErrorBoundary>
                        </React.Suspense>
                        :
                        <>
                            <ShoppingBag03 className='display-block height-1dot25rem margin-right-0dot5rem cart-btn__amount-icon'/>
                            <span className=' cart-btn__amount'>0.00 <FormattedMessage defaultMessage='UAH'/></span>
                        </>
                    }
                </Button>
            </div>
        </div>
    )
}

export default React.memo(CartButton);